/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function (algolia) {
  "use strict";
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = "<b>" + formatPrice(price) + "</b>";
    if (comparing) {
      res =
        '<span class="ais-hit--price-striked price-sale mr-2 text-gray-500"><s>' +
        formatPrice(compare_at_price) +
        "</s></span> " +
        "<b>" +
        formatPrice(price) +
        "</b>";
      /*res +=
        ' <span class="ais-hit--price-discount" style="font-weight: ' +
        Math.floor(discount_ratio * 10) * 100 +
        ';">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';*/
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  let getImgBlur = (imgSrc) => {
    var size = "50x50";
    return imgSrc.replace(/\/(.*)\.(\w{2,4})/g, "/$1_" + size + ".$2");
  };

  let createImg = (imgSrc, index, handle) => {
    //console.info("Creating image with src", imgSrc, "for ", handle)
    if (!imgSrc) return;
    let img = document.createElement("img");
    img.id = index + "--img--" + handle;
    img.src = getImgBlur(imgSrc.replace("_340x970_crop_center", ""));
    img.dataset.src = imgSrc;
    img.classList.add("lazyload");
    img.classList.add("w-full");
    img.classList.add("h-full");
    img.classList.add("absolute");
    img.classList.add("bottom-0");
    img.classList.add("left-0");
    img.classList.add("right-0");
    img.classList.add("opacity-0");
    img.classList.add("transition");
    img.classList.add("transition-opacity");
    img.classList.add("img-" + index);

    return img;
  };

  algolia.helpers = {
    // Custom Helpers by Kvalifik START
    productABV: function productABV() {
      if (this.named_tags.beerABV) {
        return 'ABV <span class="ml-3 text-black"> 4.5%</span>';
      }
    },
    productSize: function productSize() {
      if (this.named_tags.size) {
        return 'Size <span class="ml-3 text-black"> 750ml </span>';
      }
    },
    productCountry: function productCountry() {
      if (this.named_tags.beerCountry) {
        return 'Country <span class="ml-3 text-black" id="[[ handle ]]--countryText"> DK </span>';
      }
    },
    productColor: function productColor() {
      if (this.named_tags.beerColor) {
        return '<div class="flex items-center">Color <span class="ais-embedbed-hit-beerColor bg-mikkellerBeerColor12 block ml-3 rounded-full border-2 border-black w-6 h-6"></span></div>';
      }
    },

    getColSpan: function getColSpan() {
      let colSpan = "1";
      this.tags.includes("gridsize_lg") ? (colSpan = "large") : "1";
      this.tags.includes("gridsize_7") ? (colSpan = "7") : "1";
      this.tags.includes("gridsize_6") ? (colSpan = "6") : "1";
      this.tags.includes("gridsize_5") ? (colSpan = "5") : "1";
      this.tags.includes("gridsize_4") ? (colSpan = "4") : "1";
      this.tags.includes("gridsize_3") ? (colSpan = "3") : "1";
      this.tags.includes("gridsize_2") ? (colSpan = "2") : "1";
      return colSpan;
    },

    getEmbedProduct: function getEmbedProduct() {
      let embedProduct = "";
      //this.tags.includes("grid_embed") ? embedProduct = true : false // Disabled by Kvalifik march 2021 due to the embedded product feature being shelved for now.
      return embedProduct;
    },

    description: function description() {
      var res = this.body_html_safe;
      return escapeHtml(res);
    },

    getButtonColor: function getButtonColor() {
      if (
        document.querySelector('div[data-section-type="collection-template"]')
      ) {
        const collectionTemplate = document
          .querySelector('div[data-section-type="collection-template"]')
          .getAttribute("data-section-id");
        return collectionTemplate.includes("simple")
          ? "button button--blue"
          : "button";
      } else {
        return "button";
      }
    },

    /*
    // Disabled as it's currently not needed pr. 29/3 2021
    isBundle: function isBundle(){
      setTimeout(() => {
        let productCard = document.querySelector('.ais-hit[data-handle="' + this.handle + '"]')
        let productIsBundle = fetch('/products/' + this.handle + '?view=bundlesMetafields').then(response => response.json()).then(data => {
          let bundleContent = data['bundlesApp']['bundleContent--bundlesApp'] || data['bundlesApp']['bundleContent--global']
          if(bundleContent) productCard.dataset.isbundle = true;
        })
      }, 50)
    },*/

    getUntappdRating: function getUntappdRating() {
      // Disabled by Kvalifik march 2021 due to the embedded product feature being shelved for now.
      /*
      if(this.tags.includes('grid_embed')){
        console.info("Checking embedded product for Untappd info")
        let untappdInfo = fetch('/products/' + this.handle + '?view=metafields').then(response => response.json()).then(data => {
          //console.info(data)
          if(data['untappd-id']){
            console.info("Has untappd info")
            const untappdContainer = document.getElementById(this.handle + '--untappdContainer')
            untappdContainer.classList.remove('hide')
            let untappdId = data['untappd-id'];
            let score = parseFloat(data['untappd-rating']);
            let totalRatings= data['untappd-totalratings'];

            let roundedScore = Math.round((score + Number.EPSILON) * 100) / 100
            let shownScore = (Math.round(roundedScore*100)/100).toLocaleString('en');

            const untappdScoreText = document.getElementById(this.handle + "--untappdScore");
            const untappdRatingsText = document.getElementById(this.handle + "--untappdRatings");
            const productCountryContainer = document.getElementById(this.handle + '--countryContainer')
            if(data['untappd-brewery-country']){
              productCountryContainer.classList.remove('hide')
              const productCountryText = document.getElementById(this.handle + '--countryText')
              productCountryText.innerHTML = data['untappd-brewery-country']
            }
            

            untappdScoreText.innerHTML = shownScore;
            untappdRatingsText.innerHTML = new Intl.NumberFormat('da-DK').format(parseInt(totalRatings));
            
            const untappdCaps = [...document.getElementsByClassName(this.handle + "--untappdCap")]

            untappdCaps.map((cap, index) => {
              if (roundedScore > index){
                let scoreToCheck = roundedScore - index;
                if (scoreToCheck >= 1) cap.src = "https://cdn.shopify.com/s/files/1/0263/8918/4587/t/3/assets/cap-100_small.png"
                else if (scoreToCheck >= 0.66) cap.src = "https://cdn.shopify.com/s/files/1/0263/8918/4587/t/3/assets/cap-75_small.png"
                else if (scoreToCheck >= 0.56) cap.src = "https://cdn.shopify.com/s/files/1/0263/8918/4587/t/3/assets/cap-60_small.png"
                else if (scoreToCheck >= 0.50) cap.src = "https://cdn.shopify.com/s/files/1/0263/8918/4587/t/3/assets/cap-50_small.png"
                else if (scoreToCheck >= 0.15) cap.src = "https://cdn.shopify.com/s/files/1/0263/8918/4587/t/3/assets/cap-25_small.png"
                else{
                  if (scoreToCheck >= 1) cap.src = "https://cdn.shopify.com/s/files/1/0263/8918/4587/t/3/assets/cap-100_small.png"
                }
              }
            })

            let untappdLink = "https://untappd.com/b/beer/" + untappdId;
            let untappdLinkElement = document.getElementById(this.handle + '--untappdLink'); //or grab it by tagname etc
            untappdLinkElement.setAttribute("href", untappdLink);
          }
        })
      }
      */
    },

    getVariants: function getVariants() {
      // Disabled by Kvalifik march 2021 due to the embedded product feature being shelved for now.
      // When embedding products, we need to account for multiple variants.
      // Algolia does not fetch other variants, so we need to use the Shopify AJAX Api for this.
      /*if(this.tags.includes("grid_embed")){
        console.info("Getting variants for embedded product...")
        let variantSelectors = []

        const productHandle = this.handle;
        let variants = fetch('/products/' + productHandle + '.js').then(response => response.json()).then(data => {
          console.info("Shopify returned: ", data)
          if(data.variants.length > 1){
            console.info("Product has more than 1 variant")
            const variantsContainer = document.getElementById(this.objectID +'--variants');
            variantsContainer.classList.remove('hide')
            console.info("Product info: ", this)
            let variants = data.variants;
            console.info("Product variants: ", variants)

            for (const variant of variants) {
              let variantSelector = document.createElement('button')
              variantSelector.type = 'button'
              variantSelector.innerHTML = variant.title
              variantSelector.setAttribute("data-variant-id", variant.id)
    
              variantSelector.classList.add('mikkeller__variantSelector')
    
              if(variant.id == this.objectID){
                variantSelector.classList.add('js-variant-selector-active--' + this.objectID)
                variantSelector.classList.add('mikkeller__variantSelector--active')
              }
              if(variant.available){
                variantSelector.setAttribute("onclick","algolia_changeVariant('" + variant.featured_image.src + "', '" + variant.title + "', '" + variant.id + "', '" + variant.price  + "','" + this.handle + "','" + this.objectID + "')");
              }else{
                variantSelector.classList.add('mikkeller__variantSelector--disabled')
              }
              
              variantsContainer.appendChild(variantSelector);

            }
          }
        });        
      }
      */
    },

  getProductType: function getProductType() {
    if (this.named_tags.beerType) {
        if(typeof this.named_tags.beerType === 'string'){
            return this.named_tags.beerType.replaceAll('Bière de Champagne /','').replace(/,/g, ', ');
        }else{
            return this.named_tags.beerType.map((type) => type.replaceAll('Bière de Champagne /','').replace(/,/g, ', ')).join(', ');
        }
    } else {
        if (
            this._highlightResult.product_type &&
            this._highlightResult.product_type.value
        ) {
            return algolia.helpers.fullEscapedAttribute(
                this._highlightResult.product_type.value.replace('-ONLYME','').replace(/,/g, ', ')
            ); 
        }else {
            return "";
        }
    }
},


    spacedProductType: function spacedProductType() {
    const spacedProductType = getProductType.replaceAll(',', ', ');
    },

    showVariant: function showVariant() {
      let res = this.variants_count > 1 ? "block" : "hidden";
      return res;
    },

    showVariantText: function showVariantText() {
      return this.option_names[0] == "size" ? "Select size" : "View variants";
    },

    hideAddToCart: function hideAddToCart() {
      if (this.handle == "mikkeller-beer-club-1") {
        return "hidden";
      }
      let res = this.variants_count > 1 ? "hidden" : "block";
      return res;
    },

    hideQuantitySelectors: function hideQuantitySelectors() {
      if (this.handle == "mikkeller-beer-club-1") {
        return "flex opacity-0 pointer-events-none";
      }
      let res =
        this.variants_count > 1 ? "flex opacity-0 pointer-events-none mbcmove" : "flex";
      return res;
    },


  showJoinUsButton: function showJoinUsButton() {
    let targetElement = document.querySelector('.mbcmove');
    if (targetElement) {
      targetElement.insertAdjacentHTML('afterend', '<button class="join-us-button">Join Us</button>');
    }
  },

    getImage: function getImage() {
      let img = "";
      if (
        /*this.tags.includes("grid_embed") == false &&*/ this.product_type ==
          "MRC Gear" ||
        this.product_type == "MCC Gear"
      ) {
        img =
          '<img id="main-image--[[ handle ]]" src="[[# helpers.croppedMRCBlurUpImage ]][[/ helpers.croppedMRCBlurUpImage ]]" data-src="[[# helpers.getCroppedMRCImage ]][[/ helpers.getCroppedMRCImage ]]" height="1000px" width="647px" class="relative img-main lazyload self-end" alt="Featured image for [[ title ]]"/>';
      } else {
        this.title.toLowerCase().includes("bundle") ||
        this.tags.includes("gridsize_2") ||
        this.tags.includes("gridsize_3") ||
        this.tags.includes("gridsize_4") ||
        this.tags.includes("gridsize_5") ||
        this.tags.includes("gridsize_6") ||
        this.tags.includes("gridsize_7") ||
        this.product_type.toLowerCase() !== "beer"
          ? (img =
              '<img id="main-image--[[ handle ]]" src="[[# helpers.blurUpImage ]][[/ helpers.blurUpImage ]]" data-src="[[# helpers.originalImage ]][[/ helpers.originalImage ]]" height="900" width="600" class="relative img-main lazyload self-end" alt="Featured image for [[ title ]]"/>')
          : (img =
              '<img id="main-image--[[ handle ]]" src="[[# helpers.croppedBlurUpImage ]][[/ helpers.croppedBlurUpImage ]]" data-src="[[# helpers.getCroppedBeerImage ]][[/ helpers.getCroppedBeerImage ]]" height="970px" width="340px" class="relative img-main lazyload self-end" alt="Featured image for [[ title ]]"/>');
      }

      return img;
    },

    getCroppedBeerImage: function getCroppedBeerImage() {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
      }
      var size = "340x970_crop_center";
      return image.replace(/\/(.*)\.(\w{2,4})/g, "/$1_" + size + ".$2");
    },

    getCroppedMRCImage: function getCroppedBeerImage() {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
      }
      var size = "971x1500_crop_center";
      return image.replace(/\/(.*)\.(\w{2,4})/g, "/$1_" + size + ".$2");
    },

    getProductImages: async function getProductImages(text, render) {
      async function fetchImages(handle) {
        return fetch("/products/" + handle + ".js")
          .then((response) => response.json())
          .then((data) => {
            //console.info(data)
            return data.media;
          });
      }

      setTimeout(
        async function (product) {
          // Get image container and main, featured image for this product
          let productImageContainer = document.getElementById(
            "product-images--" + product.handle
          );
          let mainImage = document.getElementById(
            "main-image--" + product.handle
          );

          // Fetch raw image URLs from Shopify
          const media = await fetchImages(product.handle);
          let secondImg = "";
          let hasSecondImg = false;

          // If product has a second image, show that
          if (media.length > 1 && media[1].media_type == "image") {
            if (media[1].alt == null || media[1].alt.includes("360") == false) {
              secondImg = createImg(media[1].src, 2, product.handle);
              hasSecondImg = true;
            }
          } else {
            if (product.named_tags.beerColor || product.named_tags.funkyColor) {
              hasSecondImg = true;
              let secondImgUrl = "";
              if (product.named_tags.beerColor) {
                //console.info(product.named_tags);
                switch (product.named_tags.beerColor) {
                  case 1:
                    secondImgUrl =
                      window.beerColor1[
                        Math.floor(Math.random() * window.beerColor1.length)
                      ];
                    break;
                  case 2:
                    secondImgUrl =
                      window.beerColor2[
                        Math.floor(Math.random() * window.beerColor2.length)
                      ];
                    break;
                  case 3:
                    secondImgUrl =
                      window.beerColor3[
                        Math.floor(Math.random() * window.beerColor3.length)
                      ];
                    break;
                  case 4:
                    secondImgUrl =
                      window.beerColor4[
                        Math.floor(Math.random() * window.beerColor4.length)
                      ];
                    break;
                  case 5:
                    secondImgUrl =
                      window.beerColor5[
                        Math.floor(Math.random() * window.beerColor5.length)
                      ];
                    break;
                  case 6:
                    secondImgUrl =
                      window.beerColor6[
                        Math.floor(Math.random() * window.beerColor6.length)
                      ];
                    break;
                  case 7:
                    secondImgUrl =
                      window.beerColor7[
                        Math.floor(Math.random() * window.beerColor7.length)
                      ];
                    break;
                  case 8:
                    secondImgUrl =
                      window.beerColor8[
                        Math.floor(Math.random() * window.beerColor8.length)
                      ];
                    break;
                  case 9:
                    secondImgUrl =
                      window.beerColor9[
                        Math.floor(Math.random() * window.beerColor9.length)
                      ];
                    break;
                  case 10:
                    secondImgUrl =
                      window.beerColor10[
                        Math.floor(Math.random() * window.beerColor10.length)
                      ];
                    break;
                  case 11:
                    secondImgUrl =
                      window.beerColor11[
                        Math.floor(Math.random() * window.beerColor11.length)
                      ];
                    break;
                  case 12:
                    secondImgUrl =
                      window.beerColor12[
                        Math.floor(Math.random() * window.beerColor12.length)
                      ];
                    break;
                  case 13:
                    secondImgUrl =
                      window.beerColor13[
                        Math.floor(Math.random() * window.beerColor13.length)
                      ];
                    break;
                  case 14:
                    secondImgUrl =
                      window.beerColor14[
                        Math.floor(Math.random() * window.beerColor14.length)
                      ];
                    break;
                  case 15:
                    secondImgUrl =
                      window.beerColor15[
                        Math.floor(Math.random() * window.beerColor15.length)
                      ];
                    break;
                }
              } else {
                switch (product.named_tags.funkyColor) {
                  case "13":
                    secondImgUrl =
                      window.beerColor13[
                        Math.floor(Math.random() * window.beerColor13.length)
                      ];
                    break;
                  case "14":
                    secondImgUrl =
                      window.beerColor14[
                        Math.floor(Math.random() * window.beerColor14.length)
                      ];
                    break;
                  case "15":
                    secondImgUrl =
                      window.beerColor15[
                        Math.floor(Math.random() * window.beerColor15.length)
                      ];
                    break;
                  case "16":
                    secondImgUrl =
                      window.beerColor16[
                        Math.floor(Math.random() * window.beerColor16.length)
                      ];
                    break;
                  case "17":
                    secondImgUrl =
                      window.beerColor17[
                        Math.floor(Math.random() * window.beerColor17.length)
                      ];
                    break;
                  case "18":
                    secondImgUrl =
                      window.beerColor18[
                        Math.floor(Math.random() * window.beerColor18.length)
                      ];
                    break;
                }
              }
              var size = "340x970_crop_center";
              secondImgUrl = secondImgUrl.replace(
                /\/(.*)\.(\w{2,4})/g,
                "/$1_" + size + ".$2"
              );
              secondImg = createImg(secondImgUrl, 2, product.handle);
              secondImg.width = 340;
              secondImg.height = 970;
            }
          }
          if (hasSecondImg) {
            secondImg.alt = "Secondary image for " + product.title;
            secondImg.id = "second-image--" + product.handle;
            productImageContainer.insertBefore(secondImg, mainImage);
          }
        },
        50,
        this
      );
    },

    blurUpImage: function blurUpImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
      }
      var size = "50x50"; // Render and trim
      return image.replace(/\/(.*)\.(\w{2,4})/g, "/$1_" + size + ".$2");
    },

    croppedBlurUpImage: function croppedBlurUpImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
      }
      var size = "34x97_crop_center"; // Render and trim
      return image.replace(/\/(.*)\.(\w{2,4})/g, "/$1_" + size + ".$2");
    },

    croppedMRCBlurUpImage: function croppedMRCBlurUpImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
      }
      var size = "110x170_crop_center"; // Render and trim
      return image.replace(/\/(.*)\.(\w{2,4})/g, "/$1_" + size + ".$2");
    },

    productType: function productType() {
      return this.product_type.toLowerCase();
    },

    getBeerColor: function getBeerColor() {
      if (this.named_tags.beerColor) return this.named_tags.beerColor;
    },

    getProductSize: function getProductSize() {
      if (this.named_tags.size) {
        //let parsedSize = parseInt(this.named_tags.size.replace('ml',''))
        //let productSize = ""
        // Disabled by Kvalifik march 2021 due to the embedded product feature being shelved for now.
        // If product is embedded, we need to hide the quick add buttons that don't match product size.
        /*
        if(this.tags.includes("grid_embed")){
          productSize = parsedSize  >= 500 ? 'large' : 'small'
          setTimeout(function(){
            if(productSize == 'large'){
              const smallQuickAdds = [...document.querySelectorAll('.js-qty__add[data-product-size="small"]')]
              smallQuickAdds.map((button, index) => {
                button.classList.add('hide')
              })
    
            }else{
              const largeQuickAdds = [...document.querySelectorAll('.js-qty__add[data-product-size="large"]')]
              largeQuickAdds.map((button, index) => {
                button.classList.add('hide')
              })
            }
          }, 50)
        }
        */
        //return this.named_tags.size
      }
    },
    // Custom Helpers by Kvalifik END

    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, "");
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return "<b>" + formatPrice(min) + " - " + formatPrice(max) + "</b>";
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return (
            '<span class="ais-hit-embed-item">' +
            formatPrice(this.price) +
            '</span><b class="ais-hit-comparePrice">' +
            formatPrice(min) +
            " - " +
            formatPrice(max) +
            "</b>"
          );
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        "/products/" +
        this.handle +
        (addVariantId ? "?variant=" + this.objectID : "")
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== "Default Title" &&
        this.variant_title !== "Default"
      ) {
        res += " (" + this.variant_title + ")";
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = "";

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== "Default Title" &&
        this.variant_title !== "Default"
      ) {
        res += ' <span class="algolia-variant">(' + res + ")</span>";
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, "text/html")
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = "";

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== "Default Title" &&
        this.variant_title !== "Default"
      ) {
        res += ' <span class="algolia-variant">(' + res + ")</span>";
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return "";
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return "";
      }
    },
    floor: function floor(text, render) {
      return "" + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return "" + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
      }
      var size = render(text).replace(/^\s+|\s+$/g, ""); // Render and trim
      if (size === "original") {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, "/$1_" + size + ".$2");
    },
  };

  [
    "pico",
    "icon",
    "thumb",
    "small",
    "compact",
    "medium",
    "large",
    "grande",
    "original",
  ].forEach(function (size) {
    algolia.helpers[size + "Image"] = (function (_size) {
      return function () {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
        }

        if (_size === "original") {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, "/$1_" + _size + ".$2");
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function (res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function () {
      return function (text) {
        var render = function (value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
